import React from 'react';
import { useLocation } from 'react-router-dom';
import { useIsNotFound } from './ErrorPage/ErrorPage';
import RouteChangeTracker from './RouteChangeTracker';

const RouteChangeTrackerWrapper = () => {
    const location = useLocation();
    return <RouteChangeTracker location={location} notFound={useIsNotFound()} />;
};

export default RouteChangeTrackerWrapper;